import "./styles.scss";

import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useTask } from "context/admin/task";

import ModalNew from "components/ModalNew";
import Button from "components/Button";

const mainClass = "delete-task-modal";

const DeleteTaskModal = ({ title, isOpen, onClose }) => {
  const { t } = useTranslation();

  const { deleteTask } = useTask();
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    try {
      setLoading(true);

      await deleteTask();
      onClose();
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  return (
    <ModalNew
      title={t("Delete task")}
      variant="delete"
      loading={loading}
      hasMobileScrollTop={false}
      isOpen={isOpen}
      isSubmitHidden
      onClose={onClose}
    >
      <div className={mainClass}>
        <p>
          {t("Are you sure you want to delete the task")} "
          <strong>{title}</strong>"? <u>{t("This action cannot be undone")}</u>.
        </p>
        <div className={`${mainClass}__cta`}>
          <Button onClick={onSubmit}>{t("Delete")}</Button>
        </div>
      </div>
    </ModalNew>
  );
};

export default DeleteTaskModal;
